
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/longevity-protocol/about-project",
      function () {
        return require("private-next-pages/tools/longevity-protocol/about-project.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/longevity-protocol/about-project"])
      });
    }
  